import React, { FC } from 'react';
import { useTheme } from '@mui/material';
import { CustomIconProps } from 'interfaces';

const PrevIcon: FC<CustomIconProps> = ({ colorType }) => {
    const theme = useTheme();
    const fillColor =
        colorType === 'primary'
            ? theme.palette.primary.main
            : theme.palette.secondary.main;
    return (
        <svg
            fill={fillColor}
            width='23'
            height='25'
            viewBox='0 0 23 25'
            xmlns='http://www.w3.org/2000/svg'
        >
            <g>
                <path d='M9.22209 9.49341H20.3968C21.0823 9.52804 21.7309 9.84556 22.2131 10.3825C22.6953 10.9195 22.9757 11.6365 22.9985 12.3907C23.0213 13.1448 22.7847 13.8807 22.336 14.4516C21.8872 15.0226 21.2593 15.3866 20.5773 15.4712C18.6915 15.4712 16.8056 15.4712 14.9198 15.4712H9.20203L9.42271 15.7359C10.6666 17.1255 11.9305 18.4931 13.1543 19.8828C13.4901 20.2569 13.7306 20.7216 13.8517 21.2302C13.9728 21.7387 13.9703 22.2732 13.8443 22.7803C13.7183 23.2874 13.4734 23.7493 13.134 24.1195C12.7946 24.4897 12.3726 24.7555 11.9104 24.89C11.4529 25.0359 10.9673 25.0367 10.5094 24.8923C10.0515 24.7479 9.64001 24.4642 9.3224 24.0739C6.85474 21.3607 4.40716 18.6255 1.9395 15.8903L0.816015 14.633C0.557607 14.3538 0.352363 14.0207 0.21226 13.6534C0.0721562 13.286 0 12.8917 0 12.4934C0 12.0951 0.0721562 11.7006 0.21226 11.3333C0.352363 10.9659 0.557607 10.6329 0.816015 10.3537L9.3224 0.890865C9.66262 0.507763 10.0911 0.233409 10.5621 0.0972125C11.033 -0.0389841 11.5288 -0.0319452 11.9964 0.117542C12.4641 0.267029 12.886 0.553321 13.2171 0.945929C13.5483 1.33854 13.7762 1.82269 13.8765 2.34663C13.991 2.83708 13.9824 3.35244 13.8517 3.83795C13.721 4.32345 13.473 4.76096 13.1342 5.10389C11.9104 6.49354 10.6465 7.88323 9.40265 9.27288L9.22209 9.49341Z' />
            </g>
        </svg>
    );
};

export default PrevIcon;
